<tg-modal (close)="onClose()" size="narrow" class="tm-contact-modal">
    <form #contactUpdateDetailsForm="ngForm" (ngSubmit)="updateContactNumbers()">
        <tg-modal-header>
            <h2>Edit contact numbers</h2>
        </tg-modal-header>
        <tg-modal-body>
            Updating your contact numbers will also update your My Trade Me details.
            <tg-input-container label="Mobile"
                class="tm-contact-modal__mobile-phone-input--top-margin hide-optional-label">
                <input ngModel name="mobileNumber" tgTextInput tgInputMask [(ngModel)]="
                mobileNumber
                " [type]="'tel'" [validation]="mobilePhoneNumberValidator | toValidator"
                  placeholder="e.g. 0211234567"  (change)="onContactDetailChange()" />
                <tg-input-mask-pattern [regex]="mobilePhoneNumberRegex" pattern="*** *** *****" allow="[0-9]">
                </tg-input-mask-pattern>
            </tg-input-container>
            <tg-input-container label="Landline"
                class="tm-contact-modal__landline-input--top-margin hide-optional-label">
                <input ngModel name="landlineNumber" tgTextInput tgInputMask [(ngModel)]="
                landlineNumber
                " [type]="'tel'" [validation]="landlineNumberValidator | toValidator"
                   placeholder="e.g. 091234567" (change)="onContactDetailChange()"  />
                <tg-input-mask-pattern [regex]="homePhoneNumberRegex" pattern="** *** *******" allow="[0-9]">
                </tg-input-mask-pattern>
            </tg-input-container>
            <p class="tm-contact-modal__validate-fail" *ngIf="hasErrorInContactModal">
                Please enter at least one contact number
            </p>
        </tg-modal-body>
        <tg-modal-footer>
            <tg-row>
                <tg-col>
                    <button type="submit" [disabled]="isFormReset || !contactUpdateDetailsForm.touched  || contactUpdateDetailsForm.invalid || hasErrorInContactModal" highlight tgButton2 fullWidth
                        tgStyle="primary">Update contact details</button>
                </tg-col>
            </tg-row>
        </tg-modal-footer>
    </form>
</tg-modal>